import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK } from './arbeitsbericht-statistik.shared';

export const arbeitsberichtStatistikRoutes: Routes = [
  {
    path: 'arbeitsbericht-statistik',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/arbeitsbericht-statistik.component'),
        children: [
          {
            path: 'query',
            loadComponent: () =>
              import('./pages/query/query.component').then((m) => m.QueryComponent),
          },
          {
            path: 'result',
            loadComponent: () =>
              import('./pages/result/result.component').then((m) => m.ResultComponent),
          },
          {
            path: '**',
            redirectTo: '/arbeitsbericht-statistik/query',
          },
        ],
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK },
  },
];
